// Import our CSS
import "@/scss/glightbox.scss";

import GLightbox from "glightbox";

var lightboxInlineIframe = GLightbox({
    selector: ".glightbox",
});
